import { IRteText } from '../../interfaces/rte-text';

export interface IPreHeader {
  content: IRteText;
  isDark: boolean;
}

export const typenamePreHeaderBloc = 'preHeaderBloc';
export const PRE_HEADER_BODY_CLASS = 'pre-header-banner';
